import { Box, ListItemText, styled } from '@mui/material';
import { Accordion } from '@totalsoft/rocket-ui';

export const WorkflowLabel = styled(ListItemText)(({ theme }) => ({
  flex: 0.3,
  minWidth: '100px',
  fontWeight: theme.typography.fontWeightBold
}));

export const WorkflowValue = styled(ListItemText)(() => ({
  flex: 0.7
}));

export const WorkflowGraphDrawer = styled('div')(() => ({
  zIndex: 999,
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  width: '500px'
}));

export const WorkflowGraphDrawerMain = styled('div')(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column'
}));

export const WorkflowGraphDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  justifyContent: 'flex-end',
  height: 80,
  flexShrink: 0,
  boxShadow: '0 4px 8px 0 rgb(0 0 0 / 10%), 0 0 2px 0 rgb(0 0 0 / 10%)',
  zIndex: 1,
  backgroundColor: theme.palette.common.white
}));

export const WorkflowGraphDrawerContent = styled('div')(({ theme }) => ({
  flex: '1 1 auto',
  overflowY: 'scroll',
  position: 'relative',
  backgroundColor: theme.palette.common.white
}));

export const WorkflowsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const WorkflowAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: theme.shadows[3],
  margin: '0 !important',
  '&::before': {
    display: 'none'
  }
}));

export const WorkflowSummaryContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
